module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"meta":{"title":"ECの物流コストを削減！｜WareXで安く保管","description":"WareXの「ECモール在庫保管サービス」は、Amazon・楽天に出店中のEC事業者を支援する物流サービス。EC在庫保管の新たな選択肢に。","keywords":"EC,在庫保管"},"contact":"無料で相談する"}}')
  delete Component.options._Ctor
}
